module.exports = __webpack_public_path__ + "img/David.6b4d83c0.jpeg";